<div class="d-flex justify-content-center align-items-center w-100 h-100">
    <div class="pl-0 col-xl-4 col-md-6 col-10">
        <div class="card border-0 box-shadow rounded-0 width-size">
            <div class="card-header d-flex justify-content-center align-items-center border border-white bg-white mt-1">
               <img src = "/assets/img/cover.png" style="height: 100px;width: 250px;">
            </div>
            <div class="card-body text-center" style="margin-top: -5.5%;">
                <h1 id="title" class="title" style="color:#0D47A1;margin-bottom: 10px">Change Password?</h1>
                <form [formGroup]="ForgetPassLoginForm">
                    <div class="form-group" style="margin-bottom: 4px">
                    <label>OTP <sup style="color:red; font-size: 1.35em;
                        top: 0em;">&nbsp;*</sup></label>
                    <input class="form-control" style="border-color:#ced4da;" placeholder="OTP" type="text" autocomplete="off" formControlName="OTP" [(ngModel)]="otp"
                        name="OTP">
                    </div>
                    <span class="help-block text-danger text-center"
                    *ngIf="!ForgetPassLoginForm.get('OTP').valid && ForgetPassLoginForm.get('OTP').touched">
                        <p>OTP is required</p>
                    </span>
                    <br>
                    <div class="form-group" style="margin-bottom: 4px">
                    <label>New Password<sup style="color:red; font-size: 1.35em;
                        top: 0em;">&nbsp;*</sup></label>
                    <input class="form-control" style="border-color:#ced4da;" (keyup)="passvalid($event)" placeholder="New Password" type="password" autocomplete="off" formControlName="NP" [(ngModel)]="np"
                        name="NP">
                    </div>
                    <span class="help-block text-danger text-center"
                    *ngIf="!ForgetPassLoginForm.get('NP').valid && ForgetPassLoginForm.get('NP').touched">
                    <p>New Password is required</p>
                    </span>
                    <span class="help-block text-danger text-center"
                    *ngIf="passerror">
                    <p>Enter a valid password</p>
                    </span>
                    <br>
                    <div class="form-group" style="margin-bottom: 4px">
                    <label>Confirm Password<sup style="color:red; font-size: 1.35em;
                        top: 0em;">&nbsp;*</sup></label>
                    <input class="form-control" style="border-color:#ced4da;" (keyup)="passvalid1($event)" placeholder="Confirm Password" type="password" autocomplete="off" formControlName="CP" [(ngModel)]="cp"
                        name="CP">
                    </div>
                    <span class="help-block text-danger text-center"
                    *ngIf="!ForgetPassLoginForm.get('CP').valid && ForgetPassLoginForm.get('CP').touched">
                    <p>Confirm Password is required</p>
                    </span>
                    <span class="help-block text-danger text-center"
                    *ngIf="passerror1">
                    <p>Enter a valid password</p>
                    </span>
                    <br>
                    <div class="row">
                        <label style="font-weight: 500;color:black;margin-top: 5px;"><i>Note:&nbsp;Password should contain atleast 8 characters/
                            digits includes 1 special character, 1 lower and uppercase characters
                        </i></label>
                    </div>
                </form>

                <div class="mt-4">
                    <button class="btn blue-btn" (click)="confirmResetpassword()" [disabled]="!ForgetPassLoginForm.valid">Proceed</button>&nbsp;&nbsp;
                    <button class="btn blue-btn" (click)="confirmResendpassword()">Resend</button>&nbsp;&nbsp;
                    <button class="btn blue-btn" (click)="close()">Cancel</button>
                </div>
            </div>
        </div>
    </div> 
</div>